/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeliveryPaymentsFilter
 */
export interface DeliveryPaymentsFilter {
    /**
     * Inclusive start date without a range-length limit.
     * @type {string}
     * @memberof DeliveryPaymentsFilter
     */
    since?: string;
    /**
     * Inclusive end date without a range-length limit.
     * @type {string}
     * @memberof DeliveryPaymentsFilter
     */
    until?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DeliveryPaymentsFilter
     */
    selectedCentreIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DeliveryPaymentsFilter
     */
    selectedDomainIds?: Array<string>;
    /**
     * 
     * @type {DeliveryPaymentsFilterCustomerWholesaleEnum}
     * @memberof DeliveryPaymentsFilter
     */
    customerWholesale?: DeliveryPaymentsFilterCustomerWholesaleEnum | null;
    /**
     * 
     * @type {DeliveryPaymentsFilterMetricBasisEnum}
     * @memberof DeliveryPaymentsFilter
     */
    metricBasis?: DeliveryPaymentsFilterMetricBasisEnum;
}


/**
 * @export
 */
export const DeliveryPaymentsFilterCustomerWholesaleEnum = {
    Wholesale: 'wholesale',
    NonWholesale: 'non_wholesale',
    Unknown: 'unknown'
} as const;
export type DeliveryPaymentsFilterCustomerWholesaleEnum = typeof DeliveryPaymentsFilterCustomerWholesaleEnum[keyof typeof DeliveryPaymentsFilterCustomerWholesaleEnum];

/**
 * @export
 */
export const DeliveryPaymentsFilterMetricBasisEnum = {
    Marketing: 'marketing',
    Completed: 'completed'
} as const;
export type DeliveryPaymentsFilterMetricBasisEnum = typeof DeliveryPaymentsFilterMetricBasisEnum[keyof typeof DeliveryPaymentsFilterMetricBasisEnum];


/**
 * Check if a given object implements the DeliveryPaymentsFilter interface.
 */
export function instanceOfDeliveryPaymentsFilter(value: object): value is DeliveryPaymentsFilter {
    return true;
}

export function DeliveryPaymentsFilterFromJSON(json: any): DeliveryPaymentsFilter {
    return DeliveryPaymentsFilterFromJSONTyped(json, false);
}

export function DeliveryPaymentsFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliveryPaymentsFilter {
    if (json == null) {
        return json;
    }
    return {
        
        'since': json['since'] == null ? undefined : json['since'],
        'until': json['until'] == null ? undefined : json['until'],
        'selectedCentreIds': json['selectedCentreIds'] == null ? undefined : json['selectedCentreIds'],
        'selectedDomainIds': json['selectedDomainIds'] == null ? undefined : json['selectedDomainIds'],
        'customerWholesale': json['customerWholesale'] === undefined ? undefined : json['customerWholesale'] === null ? null : json['customerWholesale'],
        'metricBasis': json['metricBasis'] == null ? undefined : json['metricBasis'],
    };
}

export function DeliveryPaymentsFilterToJSON(json: any): DeliveryPaymentsFilter {
    return DeliveryPaymentsFilterToJSONTyped(json, false);
}

export function DeliveryPaymentsFilterToJSONTyped(value?: DeliveryPaymentsFilter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'since': value['since'],
        'until': value['until'],
        'selectedCentreIds': value['selectedCentreIds'],
        'selectedDomainIds': value['selectedDomainIds'],
        'customerWholesale': value['customerWholesale'],
        'metricBasis': value['metricBasis'],
    };
}

